export default __webpack_public_path__ + "static/media/Discord.82e13f41.png";